import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';

// Components
import { DataBlocks, FAQ, I18n } from 'components';
import { Text, Button } from '@beef/ui-kit';
import { Cards } from 'components/Cards';
import { SkeletonChildWrapper } from '../../components/SkeletonChildWrapper';

// Utils
import { templateParser } from '../../../../utils/formatString';
import { maskPhoneNumber } from '../../../../utils/validators';
import { transformAccordionData } from '../../../Family/utils';

// Actions
import { getFamilyChildInfo, setPopupStatus } from '../../store/action';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const InvitedChildLimits = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFamilyChildInfo());
  }, []);

  const {
    accumulators, sections, status, sharingDescription, ctn, isProcessing,
  } = useSelector((state) => state.familyChild);

  const maskedPhone = maskPhoneNumber(ctn);

  const description = ctn ? templateParser(sharingDescription, { NUMBER: maskedPhone }) : '';

  const handleDisconnectBtnClick = useCallback(() => {
    dispatch(setPopupStatus(true));
  }, []);

  return (
    <DataBlocks.Container>
      <DataBlocks.Block>
        <div className={cn('title')}>
          <Text
            isEllipsis
            size="size0-b"
            tagType="h2"
            testName="someName"
          >
            <I18n path="family.title" />
          </Text>
        </div>
        <SkeletonChildWrapper status={status}>
          <>
            {description && (
              <div className={cn('description')}>
                <Text size="size4-m">{description}</Text>
              </div>
            )}
            <div className={cn('cards')}>
              <Cards accumulators={accumulators} isProcessing={isProcessing} />
            </div>
            {ctn && (
              <div className={cn('button')}>
                <Button variant="plain" onClick={handleDisconnectBtnClick}>
                  <I18n path="family.disconnectBtnText"/>
                </Button>
              </div>
            )}
            <div className={cn('panel')}>
              {sections?.map((section, idx) => (
                <FAQ
                  key={idx}
                  title={section.sectionTitle}
                  questions={transformAccordionData(section?.questions)}
                />
              ))}
            </div>
          </>
        </SkeletonChildWrapper>
      </DataBlocks.Block>
    </DataBlocks.Container>
  );
};

export { InvitedChildLimits };
